__turbopack_context__.v({
  "backgroundCircle": "CharacterCountCircle-module-scss-module__DBfToq__backgroundCircle",
  "characterCountCircle": "CharacterCountCircle-module-scss-module__DBfToq__characterCountCircle",
  "characterCountCircle-enter": "CharacterCountCircle-module-scss-module__DBfToq__characterCountCircle-enter",
  "characterCountCircle-enter-active": "CharacterCountCircle-module-scss-module__DBfToq__characterCountCircle-enter-active",
  "characterCountCircle-exit": "CharacterCountCircle-module-scss-module__DBfToq__characterCountCircle-exit",
  "characterCountCircle-exit-active": "CharacterCountCircle-module-scss-module__DBfToq__characterCountCircle-exit-active",
  "characterCountContainer": "CharacterCountCircle-module-scss-module__DBfToq__characterCountContainer",
  "overLimit": "CharacterCountCircle-module-scss-module__DBfToq__overLimit",
  "progressCircle": "CharacterCountCircle-module-scss-module__DBfToq__progressCircle",
  "warning": "CharacterCountCircle-module-scss-module__DBfToq__warning",
});
